<template>
  <div class="tdb-dealroom-menu">
    <div class="extended-block">
      <h6>Funding Areas</h6>
      <menu-item
        path="/deals/platforms/tdb-health-dealroom"
        text="Health"
        caption="Healthcare and pharmaceuticals"
        @click="handleItemClick('/deals/platforms/tdb-health-dealroom')"
      />
      <menu-item
        path="/deals/platforms/tdb-infrastructure-dealroom"
        text="Infrastructure"
        caption="Infrastructure and utilities"
        @click="handleItemClick('/deals/platforms/tdb-infrastructure-dealroom')"
      />
      <menu-item
        path="/deals/platforms/tdb-climate-dealroom"
        text="Climate"
        caption="Climate and environment"
        @click="handleItemClick('/deals/platforms/tdb-climate-dealroom')"
      />
    </div>
  </div>
</template>

<script>
import MenuItem from './menu-item'

export default {
  name: 'tdb-dealroom-menu',
  components: {
    MenuItem,
  },
  methods: {
    handleItemClick(path) {
      this.$emit('hide')
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'top-menu-navigate',
        eventLabel: 'Path ' + path,
      })
      this.$gtag.event('top-menu-navigate', {
        'event_category': 'Click',
        'event_label': 'Path ' + path,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.tdb-dealroom-menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  @include desktop {
    min-width: 700px;
    flex-direction: row;
    padding: 0 $padding-l;
  }
}
.extended-block {
  padding: $padding-m $padding-s;
  @include desktop {
    padding: $padding-l $padding-m;
  }
  h6 {
    font-size: $header-label-size;
    font-weight: 600;
    margin-bottom: $margin-m;
    text-transform: uppercase;
    color: $header-secondary-color;
    padding: 0 $padding-s;
  }
}
.user-block {
  padding: $padding-l $padding-m;
  background: #fffae9;
}
</style>
